export const LARGE_WIDTH = 1200
export const MEDIUM_WIDTH = 992
export const SMALL_WIDTH = 768
export const XSMALL_WIDTH = 592
export const MOBILE_WIDTH = 414
